export default __webpack_public_path__ + "static/media/backBalls.e56a1e2e.png";